"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DomainErrorTypes = exports.DomainError = undefined;

require("source-map-support/register");

var _DomainError = require("./DomainError");

var DomainError = _interopRequireDefault(_DomainError)["default"];

var _DomainErrorTypes = require("./DomainErrorTypes");

var DomainErrorTypes = _interopRequireDefault(_DomainErrorTypes)["default"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports.DomainError = DomainError;
exports.DomainErrorTypes = DomainErrorTypes;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9FcnJvci9pbmRleC50cyJdLCJuYW1lcyI6WyJEb21haW5FcnJvciIsIkRvbWFpbkVycm9yVHlwZXMiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBOztJQUFPQSxXOztBQUNQOztJQUFPQyxnQjs7OztRQUdMRCxXLEdBQUFBLFc7UUFDQUMsZ0IsR0FBQUEsZ0IiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgRG9tYWluRXJyb3IgZnJvbSAnLi9Eb21haW5FcnJvcic7XG5pbXBvcnQgRG9tYWluRXJyb3JUeXBlcyBmcm9tICcuL0RvbWFpbkVycm9yVHlwZXMnO1xuXG5leHBvcnQge1xuICBEb21haW5FcnJvcixcbiAgRG9tYWluRXJyb3JUeXBlcyxcbn07XG4iXX0=